import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  margin-bottom: 2rem;
  padding: 2rem 5rem;

  background-color: ${pickColor('tabHoverBackground')};
  border-radius: 0.5rem;
`;

export { Container };
